export default __webpack_public_path__ + "static/media/truck-transporter_white.14915bc4.svg";